import React from 'react';
import { Container, Row, Col, Accordion, Card } from 'react-bootstrap';
import { CalculatorProvider } from './contexts/CalculatorContext';
import TransferBondCalc from './components/calculators/TransferBondCalc';
import BondRepayment from './components/calculators/BondRepayment';
import AgentCommission from './components/calculators/AgentCommission';
import CostPerSqm from './components/calculators/CostPerSqm';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// 
function App() {
  return (
    <CalculatorProvider>
      <Container fluid className="my-5" style={{ maxWidth: '1300px' }}>
        <Row>
          <Col md={6} lg={4}>
            <Accordion defaultActiveKey="0" className="border bg-white">
              {/* Transfer/Bond Cost Calculator */}
              <Accordion.Item eventKey="0">
                <Card className="mb-1">
                  <Card.Header className="p-1">
                    <Accordion.Button className="w-100 text-start btn btn-primary" style={{ letterSpacing: '1px' }}>
                      TRANSFER / BOND COST
                    </Accordion.Button>
                  </Card.Header>
                  <Accordion.Collapse eventKey="0">
                    <div className="mx-auto" style={{ maxWidth: '600px' }}>
                      <TransferBondCalc />
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion.Item>

              {/* Bond Repayment Calculator */}
              <Accordion.Item eventKey="1">
                <Card className="mb-1">
                  <Card.Header className="p-1">
                    <Accordion.Button className="w-100 text-start btn btn-primary" style={{ letterSpacing: '1px' }}>
                      BOND REPAYMENT
                    </Accordion.Button>
                  </Card.Header>
                  <Accordion.Collapse eventKey="1">
                    <div className="mx-auto" style={{ maxWidth: '600px' }}>
                      <BondRepayment />
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion.Item>

              {/* Agent Commission Calculator */}
              <Accordion.Item eventKey="2">
                <Card className="mb-1">
                  <Card.Header className="p-1">
                    <Accordion.Button className="w-100 text-start btn btn-primary" style={{ letterSpacing: '1px' }}>
                      PROPERTY PRACTITIONERS PROFESSIONAL FEE
                    </Accordion.Button>
                  </Card.Header>
                  <Accordion.Collapse eventKey="2">
                    <div className="mx-auto" style={{ maxWidth: '600px' }}>
                      <AgentCommission />
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion.Item>

              {/* Cost Per Square Meter Calculator */}
              <Accordion.Item eventKey="3">
                <Card className="mb-1">
                  <Card.Header className="p-1">
                    <Accordion.Button className="w-100 text-start btn btn-primary" style={{ letterSpacing: '1px' }}>
                      COST PER SQUARE METER
                    </Accordion.Button>
                  </Card.Header>
                  <Accordion.Collapse eventKey="3">
                    <div className="mx-auto" style={{ maxWidth: '600px' }}>
                      <CostPerSqm />
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion.Item>
            </Accordion>
          </Col>

          <Col md={6} lg={8}>
            <Row className="no-gutters py-5 py-md-0">
              <Col lg={6}>
                <img src="/images/hp1.png" className="img-fluid" alt="Property Transfer Process - Purchaser" />
              </Col>
              <Col lg={6}>
                <img src="/images/hp2.png" className="img-fluid" alt="Property Transfer Process - Seller" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </CalculatorProvider>
  );
}

export default App;
